import { createSlice } from "@reduxjs/toolkit";

const companySlice = createSlice({
  name: "company",
  initialState: {
    subscriptionDetail: "",
    companyDetail:"",
  },
  reducers: {
    subscriptionDetail(state, action) {
      console.log("data", action.payload);
      state.subscriptionDetail = action.payload;
    },
    addSubscriptionDetail(state, action) {},
    registeredCompany(state,action){
      state.companyDetail=action.payload;
    }
  },
});

export const { subscriptionDetail, addSubscriptionDetail ,registeredCompany} =
  companySlice.actions;

export default companySlice.reducer;
